import { STRIPE_DASHBOARD_TEST } from "@/constants/env.const";

/**
 * Opens the Stripe Dashboard customer page. Set `VITE_STRIPE_DASHBOARD_TEST=1`
 * when your API uses Stripe test mode so links target `/test/customers/...`.
 */
export function stripeCustomerDashboardUrl(stripeCustomerId: string): string {
  const segment = STRIPE_DASHBOARD_TEST ? "/test" : "";
  return `https://dashboard.stripe.com${segment}/customers/${encodeURIComponent(stripeCustomerId)}`;
}
